import { BACKEND_CARD_SEARCH_FILTERS } from './backendCardSearchFilters.ts';
import type { FilterConfig } from './useGQLSearch.ts';

// Omitted from the config rather than only from the filter groups: `pickRenderedBackendFilters`
// keeps every virtual filter, so `ce` and `promotion` — both resolving to a `sale.type` clause —
// would still reach `advancedFilters` from a URL a sibling market tab carried over, and
// `market.flashSalePicks` fails the request on anything `sale.*`.
const SALE_SCOPED_FILTERS = [
  'sale.price',
  'b2e',
  'sale.bundled',
  'sale.settlement_wallets',
  'sale',
  'ce',
  'promotion',
] as const;

// Left in, these would count towards the filter count and render a chip that narrows nothing —
// which would also make an unopened sale read as "no pick matches your filters".
const VIRTUAL_FILTERS_THE_PICKS_HOOK_IGNORES = [
  'co',
  'deck',
  'dk',
  'dly',
  'nl',
  'pp',
] as const;

const FILTERS_MEANINGLESS_ON_A_ROTATING_PICK = [
  'serial_number',
  'card_edition.display_name',
] as const;

const UNSUPPORTED_PICKS_FILTERS: (keyof typeof BACKEND_CARD_SEARCH_FILTERS)[] =
  [
    ...SALE_SCOPED_FILTERS,
    ...VIRTUAL_FILTERS_THE_PICKS_HOOK_IGNORES,
    ...FILTERS_MEANINGLESS_ON_A_ROTATING_PICK,
  ];

export const BACKEND_FLASH_SALE_PICKS_FILTERS = Object.fromEntries(
  Object.entries(BACKEND_CARD_SEARCH_FILTERS).filter(
    ([key]) =>
      !UNSUPPORTED_PICKS_FILTERS.some(unsupported => unsupported === key)
  )
) satisfies FilterConfig;
